/**
 * Workspace membership role from `getWorkspace` (`workspace_role` on the response).
 *
 * | Value | Constant | Description |
 * |------:|----------|-------------|
 * | `0` | `MEMBER` | Regular member (default role). |
 * | `1` | `ADMIN` | Admin: can manage members (e.g. add/remove, adjust licenses). |
 * | `2` | `SUPER_ADMIN` | Super admin: admin capabilities plus access to all speeches in the workspace. |
 * | `3` | `CX_SUPPORT` | CX support: may join customer workspaces for troubleshooting. |
 *
 * The API may still return other numbers at runtime.
 */

export const WorkspaceRole = {
  MEMBER: 0,
  ADMIN: 1,
  SUPER_ADMIN: 2,
  CX_SUPPORT: 3,
} as const;

export type WorkspaceRoleNumeric =
  (typeof WorkspaceRole)[keyof typeof WorkspaceRole];
